export interface WorkspaceRecoveryDetail {
  workspaceKey: string
}

type WorkspaceRecoveryListener = (detail: WorkspaceRecoveryDetail) => void
const listeners = new Set<WorkspaceRecoveryListener>()

export function emitWorkspaceRecovery(workspaceKey: string): void {
  const detail = { workspaceKey }
  for (const listener of listeners) listener(detail)
}

export function subscribeWorkspaceRecovery(listener: WorkspaceRecoveryListener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
